var exports = {
  "uF": "PermissionComponents.module__stateButtonsContainer___aUtGMW",
  "ev": "PermissionComponents.module__stateButton___aUtGMW",
  "uz": "PermissionComponents.module__stateButtonDisabled___aUtGMW",
  "Jj": "PermissionComponents.module__stateButtonEnabled___aUtGMW",
  "c$": "PermissionComponents.module__stateButtonDeny___aUtGMW",
  "D5": "PermissionComponents.module__stateButtonNeutral___aUtGMW",
  "N$": "PermissionComponents.module__stateButtonAllow___aUtGMW",
  "Z9": "PermissionComponents.module__stateButtonInactive___aUtGMW",
  "Ds": "PermissionComponents.module__stateDivider___aUtGMW",
  "oq": "PermissionComponents.module__overwriteToggle___aUtGMW",
  "rt": "PermissionComponents.module__overwriteToggleDense___aUtGMW",
  "HC": "PermissionComponents.module__overwriteToggleContent___aUtGMW",
  "_O": "PermissionComponents.module__overwriteToggleTitle___aUtGMW",
  "Jw": "PermissionComponents.module__overwriteToggleTitleEnabled___aUtGMW",
  "Mr": "PermissionComponents.module__overwriteToggleTitleDisabled___aUtGMW",
  "GE": "PermissionComponents.module__overwriteToggleDescription___aUtGMW",
  "fD": "PermissionComponents.module__overwriteToggleActions___aUtGMW",
  "Wk": "PermissionComponents.module__categoryContainer___aUtGMW",
  "yj": "PermissionComponents.module__categoryDivider___aUtGMW",
  "p8": "PermissionComponents.module__categoryTitle___aUtGMW",
  "LW": "PermissionComponents.module__categoryPermissions___aUtGMW",
  "wk": "PermissionComponents.module__categoryPermissionsDense___aUtGMW",
  "n2": "PermissionComponents.module__categoryPermissionsGrid___aUtGMW",
  "HF": "PermissionComponents.module__roleToggle___aUtGMW",
  "_y": "PermissionComponents.module__roleToggleDense___aUtGMW",
  "vx": "PermissionComponents.module__tooltipTriggerBlock___aUtGMW",
  "RO": "PermissionComponents.module__tooltipTriggerInline___aUtGMW",
  "Iz": "PermissionComponents.module__roleCategoryContainer___aUtGMW",
  "mj": "PermissionComponents.module__roleCategoryDivider___aUtGMW",
  "rh": "PermissionComponents.module__roleCategoryTitle___aUtGMW",
  "XC": "PermissionComponents.module__roleCategoryPermissions___aUtGMW",
  "MC": "PermissionComponents.module__roleCategoryPermissionsDense___aUtGMW",
  "bE": "PermissionComponents.module__roleCategoryPermissionsGrid___aUtGMW",
};

module.exports = exports;
